import {
    ORDER_VERSION_PREFERENCE_STORAGE_KEY,
    OrderVersionPreference,
    OrderVersionUsed,
} from 'shared/const/orderVersionPreference';

const isValidPreference = (
    value: string | null,
): value is Exclude<OrderVersionPreference, 'auto'> =>
    value === 'v1' || value === 'v2';

export const readOrderVersionPreferenceFromStorage =
    (): OrderVersionPreference => {
        const stored = localStorage.getItem(
            ORDER_VERSION_PREFERENCE_STORAGE_KEY,
        );

        if (isValidPreference(stored)) {
            return stored;
        }

        return 'auto';
    };

export const writeOrderVersionPreferenceToStorage = (
    preference: OrderVersionPreference,
): void => {
    if (preference === 'auto') {
        localStorage.removeItem(ORDER_VERSION_PREFERENCE_STORAGE_KEY);
        return;
    }

    localStorage.setItem(ORDER_VERSION_PREFERENCE_STORAGE_KEY, preference);
};

export const getOrderVersionPreferenceHeaderValue = (
    preference: OrderVersionPreference,
): OrderVersionUsed | null => {
    if (preference === 'auto') {
        return null;
    }

    return preference;
};
